

export default (state = [], action) => {
  if (action.type == "SET_PESSAH1") {
    return action.value;
  }
  return state;
};